import styles from '../../style.module.scss'
import useStore from "../../store/store";
import SummaryLine from "./summary-line";
import formatPrice from "../../utils/format-price";
import SummaryPromoCode from "./summary-promocode";
import SummaryBonus from "./summary-bonus";
import {useState} from "react";
import ChevronDownIcon from "../ui/icons/chevron-down-icon";
import {serviceType} from "../../utils/service-type";
import SummaryHead from "./summary-head";
import Submit from "../submit/submit";

const Summary = ({rates, car, promoFinishDate, promoPriceGrid, priceGrid, insurances, services, links}) => {
    const rateDayPayMode = false;//soon..
    const currentInsurance = useStore((state) => state.currentInsurance)
    const carDeliveryLocation = useStore((state) => state.carDeliveryLocation)
    const carReturnLocation = useStore((state) => state.carReturnLocation)
    const currentRate = useStore((state) => state.currentRate)
    const startDate = useStore((state) => state.startDate)
    const startHours = useStore((state) => state.startHours)
    const finishDate = useStore((state) => state.finishDate)
    const finishHours = useStore((state) => state.finishHours)
    const carServices = useStore((state) => state.carServices)
    const promoCodeSale = useStore((state) => state.promoCodeSale)
    const user = useStore((state) => state.user)
    const bonusPay = useStore((state) => state.bonusPay)

    const [showCheck, setShowCheck] = useState(false);
    const limitKm = () => {
        return rates.find(item => item.id === currentRate)?.limit || null;
    }
    const countDays = () => {
        if (startDate && startHours !== null && finishDate && finishHours !== null) {
            const oneDay = 24 * 60 * 60 * 1000;
            const start = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), startHours, 0, 0);
            const finish = new Date(finishDate.getFullYear(), finishDate.getMonth(), finishDate.getDate(), finishHours - 1, 0, 0);
            return Math.ceil(Math.abs((finish - start) / oneDay));
        }
        return null;
    }
    const getListPrices = () => {

        if ((currentRate === 1 || currentRate === 2) && !!promoFinishDate && !!promoPriceGrid) {
            const date = new Date(promoFinishDate);
            if (date >= startDate) {
                return promoPriceGrid;
            }
        }
        if (priceGrid[currentRate]) {
            return priceGrid[currentRate];
        }

        return [];
    }

    const getRate = () => rates.filter((rate) => rate.id === currentRate)?.[0]
    const getRateDayPrice = () => {
        const days = countDays();
        const priceData = getListPrices().filter((item) => item.days_min <= days && days <= item.days_max)?.[0]
        if (priceData) {
            return priceData?.price || null;
        }

        return null;
    }
    const getInsuranceDayPrice = () => {
        if (currentInsurance) {
            const insurance = insurances.filter((item) => item.caraddonid === currentInsurance)?.[0];
            if (insurance) {
                return parseInt(insurance?.caraddonprice || 0);
            }
        }
        return 0;
    }
    const getCarDeliveryLocationPrice = () => {
        if (carDeliveryLocation) {
            const service = services.filter((item) => item.caraddonid === carDeliveryLocation)?.[0];
            if (service) {
                return parseInt(service?.caraddonprice || 0);
            }
        }
        return 0;
    }
    const getCarReturnLocationPrice = () => {
        if (carReturnLocation) {
            const service = services.filter((item) => item.caraddonid === carReturnLocation)?.[0];
            if (service) {
                return parseInt(service?.caraddonprice || 0);
            }
        }
        return 0;
    }
    const getRateSum = () => {
        return countDays() * getRateDayPrice();
    }
    const getInsuranceSum = () => {
        return countDays() * getInsuranceDayPrice();
    }
    const getServicesSum = () => {
        let sum = 0;
        if (!!carServices && !!carServices.length) {
            for (let i = 0; i < carServices.length; i++) {
                const serviceId = carServices[i].serviceId;
                const service = services.find((item) => item.caraddonid === serviceId)
                if (!!service) {
                    if (serviceType(service.caraddontype) === 'one_time') {
                        sum += parseInt(service.caraddonprice);
                    }
                    if (serviceType(service.caraddontype) === 'day') {
                        sum += countDays() * parseInt(service.caraddonprice);
                    }
                }
            }
        }
        return sum;
    }
    const getSalePercent = (p = true) => {
        if (!!user && !!user.sale && !!promoCodeSale) {
            if (user.sale > promoCodeSale) {
                return p ? user.sale : [user.sale, 'card'];
            } else {
                return p ? promoCodeSale : [promoCodeSale, 'promo'];
            }
        } else {
            if (!!user && !!user.sale) {
                return p ? user.sale : [user.sale, 'card'];
            } else {
                if (!!promoCodeSale) {
                    return p ? promoCodeSale : [promoCodeSale, 'promo'];
                }
            }
        }
        return p ? 0 : [0, null];
    }
    const getSum = () => {
        let sum = 0;
        sum += getRateSum();
        if (sum > 1 && getSalePercent() > 0) {
            sum = sum * (100 - getSalePercent()) / 100;
        }

        sum += getInsuranceSum();
        sum += getCarDeliveryLocationPrice();
        sum += getCarReturnLocationPrice();
        sum += getServicesSum();
        if (!!user && !!user.bonus && bonusPay) {
            if (user.bonus > sum) {
                sum = 1;
            } else {
                sum -= user.bonus;
            }
        }

        return Math.round(sum);
    }

    if (!currentRate || !car || !priceGrid) {
        return null;
    }

    return (
        <div className={styles.summary}>
            <SummaryHead/>
            <div className={styles.body}>

                <SummaryLine label={`Тариф`} value={getRate().name}/>
                {
                    !!car.carzalog && (
                        <SummaryLine label={`Залог`} value={`от ${formatPrice(car.carzalog)}`}/>)
                }
                {
                    !!limitKm() && (<SummaryLine label={`Пробег`} value={`${limitKm()} км`}/>)
                }
                {
                    !!car.carkmprice && !rateDayPayMode && (
                        <SummaryLine label={`Перепробег`} value={`${formatPrice(car.carkmprice)} /км.`}/>)
                }
                {
                    !!car.carkmprice && rateDayPayMode && (
                        <SummaryLine label={`Цена за 1 км.`} value={`${formatPrice(car.carkmprice)}`}/>)
                }
                {
                    !!countDays() && (<SummaryLine label={`Количество суток аренды`} value={`${countDays()}`}/>)
                }
                <SummaryPromoCode car={car}/>
                <SummaryBonus/>
                <div className={styles.hr}/>
                <div className={styles.check}>
                    <div className={`${styles.showButton} ${showCheck && styles.active} p-extra-small-size`}
                         onClick={() => setShowCheck(!showCheck)}>
                        Расчет стоимости
                        <ChevronDownIcon/>
                    </div>
                    {
                        showCheck && (
                            <div className={styles.showList}>
                                <SummaryLine label={`По тарифу`} value={formatPrice(getRateSum())}/>
                                {
                                    !!getSalePercent() && getSalePercent(false)[1] === 'promo' && (
                                        <SummaryLine label={`Скидка промокод`} value={`-${getSalePercent()}%`}/>
                                    )
                                }
                                {
                                    !!getSalePercent() && getSalePercent(false)[1] === 'card' && (
                                        <SummaryLine label={`Личная скидка`} value={`-${getSalePercent()}%`}/>
                                    )
                                }
                                {
                                    !!getInsuranceSum() && (<SummaryLine label={`Пакет снижения ответственности`}
                                                                         value={formatPrice(getInsuranceSum())}/>)
                                }
                                {
                                    !!getCarDeliveryLocationPrice() && (
                                        <SummaryLine label={`Подача авто`} value={formatPrice(getCarDeliveryLocationPrice())}/>)
                                }
                                {
                                    !!getCarReturnLocationPrice() && (
                                        <SummaryLine label={`Возврат авто`} value={formatPrice(getCarReturnLocationPrice())}/>)
                                }
                                {
                                    !!getServicesSum() && (
                                        <SummaryLine label={`Дополнительные услуги`} value={formatPrice(getServicesSum())}/>)
                                }
                                {
                                    !!user && !!user.bonus && bonusPay && (
                                        <SummaryLine label={`Бонусы`} value={`-${formatPrice(user.bonus)}`}/>
                                    )
                                }

                            </div>
                        )
                    }

                </div>
                <div className={styles.hr}/>
                <div className={`${styles.sum} h2-size`}>Итого: {formatPrice(getSum())}</div>
                <Submit countDays={countDays()} rateSum={getRateSum()} sale={getSalePercent(false)} rate={getRate()}/>
                {
                    !!links && (<div className={styles.links}>
                        {!!links.tel && (
                            <a href={links.tel.link} target='_blank' className={`${styles.link} ${styles.tel}`}>
                                <img src={links.tel.icon} width={24} height={24} alt='tel icon'/>
                            </a>)}
                        {!!links.whatsapp && (
                            <a href={links.whatsapp.link} target='_blank' className={`${styles.link} ${styles.whatsapp}`}>
                                <img src={links.whatsapp.icon} width={24} height={24} alt='whatsapp icon'/>
                            </a>)}
                        {!!links.telegram && (
                            <a href={links.telegram.link} target='_blank' className={`${styles.link} ${styles.telegram}`}>
                                <img src={links.telegram.icon} width={24} height={24} alt='telegram icon'/>
                            </a>)}
                    </div>)
                }
                <div className={`${styles.description} p-extra-small-size `}>
                    Нажимая на кнопку "Отправить заявку" Вы соглашаетесь на обработку персональных данных
                </div>
            </div>
        </div>
    );
};

export default Summary;